import React from 'react';
import { Grid } from 'react-styled-flexboxgrid';

import { BUTTON_TYPES } from '@savgroup-front-common/constants';
import { Button } from '@savgroup-front-common/core/atoms/button';
import { SafeFormattedMessageWithoutSpread } from '@savgroup-front-common/core/formatters';
import { SUPPORTED_ICON_POSITIONS } from '@savgroup-front-common/core/helpers';
import ArrowNakedLeftIcon from '@savgroup-front-common/core/protons/icons/ArrowNaked/ArrowNakedLeft.icon';
import { ArrowNakedRightIcon } from '@savgroup-front-common/core/protons/icons/ArrowNaked/ArrowNakedRight.icon';

import { $Footer, $RowFooter } from '../StepLayout.styles';

import messages from './messages';

interface StepFooterProps {
  handlePreviousStep?: () => void;
  noConfirmButton?: boolean;
  isFirstStep?: boolean;
  isDisabled?: boolean;
  isLoading?: boolean;
}

const StepFooter: React.FC<StepFooterProps> = ({
  handlePreviousStep = () => undefined,
  noConfirmButton = false,
  isFirstStep = false,
  isDisabled = false,
  isLoading = false,
}) => {
  return (
    <$Footer>
      <Grid>
        <$RowFooter between="xs" isFirstStep={isFirstStep}>
          {!isFirstStep && (
            <Button
              type={BUTTON_TYPES.BUTTON}
              tertiary
              naked
              onClick={handlePreviousStep}
              icon={<ArrowNakedLeftIcon />}
              position={SUPPORTED_ICON_POSITIONS.LEFT}
              dataTestId="previousButton"
            >
              <SafeFormattedMessageWithoutSpread
                message={messages.previousButton}
              />
            </Button>
          )}
          {!noConfirmButton && (
            <Button
              type={BUTTON_TYPES.SUBMIT}
              primary
              icon={<ArrowNakedRightIcon />}
              position={SUPPORTED_ICON_POSITIONS.RIGHT}
              disabled={isDisabled}
              isLoading={isLoading}
              dataTestId="nextButton"
            >
              <SafeFormattedMessageWithoutSpread
                message={messages.nextButton}
              />
            </Button>
          )}
        </$RowFooter>
      </Grid>
    </$Footer>
  );
};

export default StepFooter;
